import angular from 'angular';

angular
  .module('cxRegistrations')
  .controller('DeleteResourceDialogCtrl', [
    'close',
    'resourceFactorySvc',
    'flySvc',
    'category',
    'resource',
    '$element',
    '$http',
    'appUrls',
    '$q',
    'appMessages',
    'translateListFilter',
    'resourceNameFilter',
    deleteResourceDialogCtrl,
  ]);

function deleteResourceDialogCtrl(
  close,
  resourceFactorySvc,
  flySvc,
  category,
  resource,
  $element,
  $http,
  appUrls,
  $q,
  appMessages,
  translateListFilter,
  resourceNameFilter,
) {
  const vm = this;
  vm.message = appMessages('comfirmDeleteResource', { name: resource.name });

  const resources = [resource];
  const resourceIds = resources.map(x => x.id);
  vm.usedResources = [];
  vm.allResources = [];
  vm.saving = false;
  const regResource = resourceFactorySvc.get('resource');

  function getTaskData() {
    //Only do request for work & costs
    if (category.type !== 0 && category.type !== 1) return $q.when([]);
    return $http
      .post(`${appUrls.tasks}/api/PlannedTasks/ResourcesUsage`, {
        resourceIds,
        isCost: category.type === 1,
      })
      .then(({ data }) => data || {});
  }

  function getMainData() {
    return $http
      .post(`${appUrls.api}/api/Resource/ResourcesUsage`, resourceIds)
      .then(({ data }) => data || {});
  }

  $q.all([getTaskData(), getMainData()]).then(
    ([taskData, mainData]) => {
      vm.usedResources = resources.reduce((result, resource) => {
        const r = {
          ...resource,
          taskTemplates: ((taskData.taskTemplates || {})[resource.id] || []).map(t => {
            //Translate task names
            const mainTemplateName = translateListFilter(
              t.mainTemplateId,
              'TaskTemplate',
              t.mainTemplateName,
            );
            if (t.mainTemplateId === t.id) return { ...t, label: mainTemplateName };
            const subTemplateName = translateListFilter(t.id, 'TaskTemplate', t.name);
            return { ...t, label: `${mainTemplateName} - ${subTemplateName}` };
          }),
          tasksWithTemplate: (taskData.tasksWithTemplate || {})[resource.id] || 0,
          tasksWithoutTemplate: (taskData.tasksWithoutTemplate || {})[resource.id] || 0,
          plannedRegistrations: (mainData.plannedRegistrations || {})[resource.id] || 0,
          settings: (mainData.settings || {})[resource.id] || 0,
          collapsed: true,
          replaceWith: null,
        };
        if (r.taskTemplates.length > 0) r.collapsed = false;

        if (
          r.taskTemplates.length === 0 &&
          r.tasksWithTemplate === 0 &&
          r.tasksWithoutTemplate === 0 &&
          r.plannedRegistrations === 0 &&
          r.settings === 0
        )
          return result;

        result.push(r);
        return result;
      }, []);

      if (vm.usedResources.length > 0) {
        regResource.reg({ type: category.type }).$promise.then(function(data) {
          vm.allResources = data
            .filter(x => resourceIds.indexOf(x.id) < 0)
            .map(item => ({
              ...item,
              label: resourceNameFilter(item),
              code: item.code || '',
            }));
        });
      }
    },
    error => {
      flySvc.error(error);
    },
  );

  vm.isValid = function() {
    if (vm.usedResources.length === 0) return true;
    if (vm.usedResources.some(x => !x.replaceWith || !x.replaceWith.id)) return false;
    return true;
  };
  vm.save = function() {
    if (vm.saving || !vm.isValid()) return;
    vm.saving = true;
    regResource.deleteResource(
      {
        id: resource.id,
      },
      {
        replacements: vm.usedResources.reduce((o, r) => {
          o[r.id] = r.replaceWith.id;
          return o;
        }, {}),
      },
      ({ data: isRemoved }) => {
        $element.modal('hide');
        close({ isRemoved }, 500);
      },
      error => {
        flySvc.error(error);
      },
    );
  };
  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
